import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../../components/base/Modal";
import { AvisoForm } from "../AvisoForm";
import type { AvisoFormData, ThemeClasses } from "../types";

interface EditAvisoModalProps {
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  form: UseFormReturn<AvisoFormData>;
  loadingSubmit: boolean;
  scopeLabel: string;
  scopeKind: "global" | "company";
  imagePreview: string | null;
  onImageChange: (file: File | null) => void;
  onClearImage: () => void;
  onClose: () => void;
  onSubmit: (data: AvisoFormData) => void;
}

export default function EditAvisoModal({
  isDarkMode,
  themeClasses,
  form,
  loadingSubmit,
  scopeLabel,
  scopeKind,
  imagePreview,
  onImageChange,
  onClearImage,
  onClose,
  onSubmit,
}: EditAvisoModalProps) {
  const { t } = useTranslation("adminSections");
  return (
    <Modal
      themeClasses={themeClasses}
      onClose={onClose}
      title={t("avisos.editTitle")}
      content={
        <AvisoForm
          form={form}
          isEdit
          loadingSubmit={loadingSubmit}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          scopeLabel={scopeLabel}
          scopeKind={scopeKind}
          imagePreview={imagePreview}
          onImageChange={onImageChange}
          onClearImage={onClearImage}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      }
    />
  );
}
